import { TableHeadersType } from "../tableHeadersType";

export const USER_WORKING_ON_PARTICULAR_JOBS_HEADERS: TableHeadersType[] = [
    {
      "label": "EMPLOYEE",
      "value": "userName",
    
    },
    {
      "label": "Hours",
      "value": "hours",
    },
    {
      "label": "Rate employee’s work",
      "value": "rateEmployeesWork",
    },
  ]